import { api } from "./apiClient";
import { Solicitud } from "@/types/solicitud";

export const expedientesService = {
  getSolicitudes: (fechaInicio?: string, fechaFin?: string) => {
    const params = new URLSearchParams();
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);
    const query = params.toString();
    return api.get<Solicitud[]>(`/expedientes/solicitudes${query ? '?' + query : ''}`);
  },
};
